import React, { useContext, useState } from "react";
import { Grid } from "react-feather";
import { Link } from "react-router-dom";
import { Image } from "../../AbstractElements";
import CubaIcon from "../../assets/images/logo/logo.png";
import CustomizerContext from "../../_helper/Customizer";
import { useEffect } from "react";
import hofficeicon from "../../assets/images/supportportal/h_office_logo.png";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { MENUITEMS } from "./Menu";

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, toggleIcon, layout, layoutURL } =
    useContext(CustomizerContext);
  // const baseurl = "https://hofficedemo4.ondemandcrm.co";
  const baseurl = useSelector((store) => store.baseUrl);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );

  useEffect(() => {
    const userdetails = JSON.parse(localStorage.getItem("userdetails"));
    if (userdetails != null) {
      setUserdetails(userdetails);
    }
  }, []);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  // `${baseurl}/${userdetails?.company_logo}`
  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  function getDashboardLink() {
    const IS_POS = process.env.REACT_APP_IS_POS;
    switch (IS_POS) {
      case "0":
        return `${process.env.PUBLIC_URL}/timesheetportal`;
      case "1":
        return `${process.env.PUBLIC_URL}/dashboardposmain`;
      case "3":
        return `${process.env.PUBLIC_URL}/dashboard`;
      default:
        return `${process.env.PUBLIC_URL}/dashboard`; // Default to /dashboard if IS_POS is not 0, 1, or 3
    }
  }

  const companyLogoAttrImage = {
    className: "d-inline",
    src: `${baseurl}/${userdetails?.company_logo}`,
    alt: "",
    style: {
      height: "60px",
      maxWidth: "100%",
    },
  };

  const sidebarItemCount = MENUITEMS.reduce(
    (n, block) => n + (Array.isArray(block.Items) ? block.Items.length : 0),
    0
  );

  const location = useLocation();
  const pathSegs = location.pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const hideSidebarBars = pathSegs[pathSegs.length - 1] === "dashboardpos";

  return (
    <div className="logo-wrapper">
      {layout1 !== "compact-wrapper dark-sidebar" &&
      layout1 !== "compact-wrapper color-sidebar" &&
      mixLayout ? (
        <div className="dashboard-logo">
          <Link to={getDashboardLink()}>
            <Image attrImage={companyLogoAttrImage} />
          </Link>
        </div>
      ) : (
        <div className="dashboard-logo">
          <Link to={getDashboardLink()}>
            <Image attrImage={companyLogoAttrImage} />
          </Link>
        </div>
      )}

      {/* <div
        style={{ color: "#81a080", fontSize: "30px", fontWeight: "600" }}
        className="back-btn"
        onClick={() => openCloseSidebar()}
      >
        <i className="fa fa-angle-left"></i>
      </div>
      <div className="toggle-sidebar" onClick={openCloseSidebar}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div> */}

      {/* <div className="back-btn" onClick={() => openCloseSidebar()}>
        <i className="fa fa-angle-left"></i>
      </div> */}
      {sidebarItemCount > 0 && !hideSidebarBars && (
        <div className="back-btn" onClick={() => openCloseSidebar()}>
          <i className="fa fa fa-bars" style={{ color: "#26994E" }}></i>
        </div>
      )}
      {/* <div className="toggle-sidebar" onClick={openCloseSidebar}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div> */}
    </div>
  );
};

export default SidebarLogo;
